export enum ScenarioDecision {
  UNDECIDED = "UNDECIDED", // 미결정
  APPROVED = "APPROVED", // 승인
  REJECTED = "REJECTED", // 반려
  CANCELED = "CANCELED", // 취소
}

export const SCENARIO_DECISION_LABELS: Record<ScenarioDecision, string> = {
  [ScenarioDecision.UNDECIDED]: "미결정",
  [ScenarioDecision.APPROVED]: "승인",
  [ScenarioDecision.REJECTED]: "반려",
  [ScenarioDecision.CANCELED]: "취소",
};
